// @flow

import invariant from 'invariant';

import _ from 'lodash';

import ko from 'rgs-knockout';
import type {
	Observable,
	PureComputed,
} from 'rgs-knockout';

import moment from 'moment';
const { duration } = moment;

import { durationPrettyReprExtend } from 'ko-extender-repr-pretty-duration';

export type ObservableDisableTimerOptions = {
	timeout?: ?(number | Object | [number, string]),
};

function durationToMilliseconds (d: ?(number | Object | [number, string])): ?number {
	if (_.isArray(d)) {
		d = ((d: any): [number, string]);
		return duration(...d).asMilliseconds();
	} else if (_.isObject(d)) {
		d = ((d: any): Object);
		return duration(d).asMilliseconds();
	} else if (_.isNumber(d)) {
		return ((d: any): number);
	}
	return null;
}

const TICK_INTERVAL = 1000;

export class ObservableDisableTimer {
	_timeoutRemaining: Observable<number>;

	_timeout: ?number;

	_tickInterval: ?number;

	timeoutRemaining: PureComputed<number>;

	constructor (options?: ObservableDisableTimerOptions = {}) {
		options.timeout = durationToMilliseconds(options.timeout);

		this._timeout = options.timeout;

		this._timeoutRemaining = ko.observable(0);

		this.timeoutRemaining = ko.pureComputed(() => this._timeoutRemaining())
			.extend(durationPrettyReprExtend);

		this.isDisabled = ko.pureComputed(() => this._timeoutRemaining() > 0);
	}

	dispose () {
		this._clearInterval();
	}


	// isDisabled () {
	// 	return this._timeoutRemaining() > 0;
	// }

	disable (options?: ObservableDisableTimerOptions) {
		const timeout = durationToMilliseconds((options && options.timeout) || this._timeout);

		invariant(
			timeout,
			'You should either pass `timeout` option to `ObservableDisableTimer` constructor'
				+ ' or pass it to `disable` method'
		);

		this._timeoutRemaining(Math.max(this._timeoutRemaining(), timeout));
		this._setInterval();
	}

	change (options?: ObservableDisableTimerOptions) {
		const timeout = durationToMilliseconds((options && options.timeout) || this._timeout);

		invariant(
			timeout,
			'You should either pass `timeout` option to `ObservableDisableTimer` constructor'
				+ ' or pass it to `disable` method'
		);

		this._timeoutRemaining(timeout);
		this._setInterval();
	}


	_setInterval () {
		this._clearInterval();
		this._tickInterval = setInterval(() => this._tick(), TICK_INTERVAL);
	}

	_clearInterval () {
		if (!this._tickInterval) {
			return;
		}
		clearInterval(this._tickInterval);
	}

	_tick () {
		if (!this.isDisabled()) {
			return;
		}

		this._timeoutRemaining(Math.max(0, this._timeoutRemaining() - TICK_INTERVAL));

		if (this._timeoutRemaining() <= 0) {
			this._clearInterval();
		}
	}
}
